import {
  IntRange1cx8zvxgibbj2 as IntRange,
  LongRange138sb2ngfio7d as LongRange,
} from '../ranges/PrimitiveRanges.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function numberRangeToNumber(start, endInclusive) {
  return new (IntRange())(start, endInclusive);
}
function longRangeToLong(start, endInclusive) {
  return new (LongRange())(start, endInclusive);
}
//region block: exports
export {
  longRangeToLong as longRangeToLong1wnzlyc7cu6kp,
  numberRangeToNumber as numberRangeToNumber25vse2rgp6rs8,
};
//endregion

//# sourceMappingURL=rangeTo.mjs.map
